<div class="container-fluid border-bottom px-4 d-flex align-items-center flex-wrap">
  <button cHeaderToggler [cSidebarToggle]="sidebarId" toggle="visible" class="btn"
    style="margin-inline-start: -14px;" aria-label="Toggle sidebar">
    <svg cIcon name="cilMenu" size="lg"></svg>
  </button>
  <c-header-nav class="ms-auto align-items-center">
    <app-session-countdown></app-session-countdown>
    <c-dropdown alignment="end" variant="nav-item">
      <a cDropdownToggle class="nav-link py-0 pe-0" role="button" aria-label="Account menu">
        <img src="assets/img/Blank-Avatar.png" class="avatar avatar-md" alt="Account" />
      </a>
      <ul cDropdownMenu>
        <li><h6 cDropdownHeader class="text-center"><strong>Account</strong></h6></li>
        <li><a cDropdownItem (click)="changePassword()"><i class="fa fa-shield me-2"></i> Change Password</a></li>
        <li><a cDropdownItem (click)="logout()"><i class="fa fa-lock me-2"></i> Logout</a></li>
      </ul>
    </c-dropdown>
  </c-header-nav>
</div>
<div class="container-fluid px-4">
  <c-breadcrumb-router class="my-0"></c-breadcrumb-router>
</div>
